import { createLoader, createParser, parseAsString } from 'nuqs/server'

const parseAsDenom = createParser({
  parse: (value: string) => decodeURIComponent(value),
  serialize: (value: string) => encodeURIComponent(value),
})

export const fromSearchParamsParsers = {
  fromChain: parseAsString,
  fromToken: parseAsDenom,
  fromAmount: parseAsString.withDefault(''),
}

export const fromSearchParamsLoader = createLoader(fromSearchParamsParsers)

export const toSearchParamsParsers = {
  toChain: parseAsString,
  toToken: parseAsDenom,
}
export const toSearchParamsLoader = createLoader(toSearchParamsParsers)

export const referralSearchParamsParses = {
  referrer: parseAsString,
}

export const referralSearchParamsLoader = createLoader(
  referralSearchParamsParses,
)
